var players = new Array();
function getUrlVars(){
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for(var i = 0; i < hashes.length; i++){
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}
$(document).ready(function($){
  $(".youtube-link").grtyoutube({
    autoPlay:true,
    theme: "dark"
  });

});
$( window ).resize(function() {
  var hheight = $( window ).height();
  var theight = $( window ).height() * (70 / 100 );
  var mtheight = $( window ).height() * (15 / 100 );
  var hheight = theight + 'px';
  var wwidth = $( window ).width();
  var twidth = $( window ).width() * (80 / 100 );
  var wwidth = twidth + 'px';
  $(".grtyoutube-popup-content").css("width",wwidth);
  $(".grtyoutube-popup-content").css("height",hheight);
  $(".grtyoutube-popup-content").css("margin-top",mtheight);
  $(".grtyoutube-popup-content iframe").css("width",wwidth);
  $(".grtyoutube-popup-content iframe").css("height",hheight);
});
// create youtube player
var player;
function onYouTubePlayerAPIReady(videoId) {
  var hheight = $( window ).height();
  var theight = $( window ).height() * (70 / 100 );
  var mtheight = $( window ).height() * (15 / 100 );
  var hheight = theight + 'px';
  var wwidth = $( window ).width();
  var twidth = $( window ).width() * (80 / 100 );
  var wwidth = twidth + 'px';
  $(".grtyoutube-popup-content").css("width",wwidth);
  $(".grtyoutube-popup-content").css("height",hheight);
  $(".grtyoutube-popup-content").css("margin-top",mtheight);
  player = new YT.Player('grtyoutube-iframe', {
    videoId: videoId,
    height: hheight,
    width: wwidth,
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange
    }
  });
  players.push(player);
  var grtIframe =  $("#grtyoutube-iframe");
  if(grtIframe.length > 0)
    $("#grtyoutube-iframe")[0].src += "&modestbranding=0&showinfo=0&autohide=1&rel=0&control=0&iv_load_policy=3&nologo=1&enablejsapi=1&playsinline=1";
}

// autoplay video
function onPlayerReady(event) {
  event.target.playVideo();
}

// when video ends
function onPlayerStateChange(event) {    
  if(event.data === 0) {          
    $(".grtyoutube-popup-close").trigger("click");
    for (var i = 0; i < players.length; i++) {
      player = players[i].Y;
      if(player){
        $('#grtyoutube-iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        players.pop();
      }

    }
  }
}

function onCloseAllPlayers(event){
  for (var i = 0; i < players.length; i++) {
    player = players[i].Y;
    if(player){
      //player.stopVideo();
      //javascript:document.getElementById('ytplayer').stopVideo();
      $('#grtyoutube-iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      players.pop();
    }
  }
}
